
import { defineComponent, PropType } from 'vue';
import SvgTrailerShell from '@/components/Icons/SvgTrailerShell.vue';
import SvgProhibitedBadge from '@/components/Icons/SvgProhibitedBadge.vue';
import SvgVerifiedBadge from '@/components/Icons/SvgVerifiedBadge.vue';
import SvgSwiftTrailerDriver from '@/components/Icons/SvgSwiftTrailerDriver.vue';
import SvgKnightTrailerDriver from '@/components/Icons/SvgKnightTrailerDriver.vue';
import CompanyLogo from '@/components/Icons/CompanyLogo.vue';
import { CompanyCodes } from '@/types/CompanyCodes';
import { VirtualRedTagTrailerGraphicState } from '@/types/VirtualRedTagTrailerGraphicState';

const SHELL_COLORS: Record<VirtualRedTagTrailerGraphicState, string> = {
    [VirtualRedTagTrailerGraphicState.default]: '#615F5A',
    [VirtualRedTagTrailerGraphicState.blocked]: '#A81C1E',
    [VirtualRedTagTrailerGraphicState.success]: '#709B34',
    [VirtualRedTagTrailerGraphicState.redTagged]: '#615F5A',
};

export default defineComponent({
    name: 'VirtualRedTagTrailerGraphic',
    components: {
        SvgTrailerShell,
        SvgProhibitedBadge,
        SvgVerifiedBadge,
        SvgSwiftTrailerDriver,
        SvgKnightTrailerDriver,
        CompanyLogo,
    },
    props: {
        state: {
            type: String as PropType<VirtualRedTagTrailerGraphicState>,
            default: VirtualRedTagTrailerGraphicState.default,
        },
        company: {
            type: String,
            default: undefined,
        },
    },
    computed: {
        GraphicState(): typeof VirtualRedTagTrailerGraphicState {
            return VirtualRedTagTrailerGraphicState;
        },
        // The default state shows the company's full trailer illustration (logo
        // included) instead of the plain shell with a logo overlaid on it.
        companyIllustration(): string | null {
            if (this.state !== VirtualRedTagTrailerGraphicState.default) {
                return null;
            }

            switch (this.company) {
                case CompanyCodes.SWIFT:
                    return 'SvgSwiftTrailerDriver';
                case CompanyCodes.KNIGHT:
                    return 'SvgKnightTrailerDriver';
                default:
                    return null;
            }
        },
        shellColor(): string {
            return SHELL_COLORS[this.state];
        },
    },
});
